"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Definition = void 0;
const lodash_functions_1 = require("../../../../util/lodash-functions");
const default_session_1 = require("../../../../session/default-session");
const curves_provider_1 = require("../curves-provider");
function Definition(params) {
    let parameters;
    if ((0, lodash_functions_1.isPlainObject)(params)) {
        parameters = params;
    }
    else {
        parameters = {
            universe: params,
        };
    }
    return {
        getData(session = (0, default_session_1.getDefault)()) {
            const curvesProvider = new curves_provider_1.CurvesProvider(session);
            return curvesProvider.getZcCurveDefinitions(parameters);
        },
    };
}
exports.Definition = Definition;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGVmaW5pdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uL3NyYy9jb250ZW50L2lwYS9jdXJ2ZXMvemMtY3VydmUtZGVmaW5pdGlvbnMvZGVmaW5pdGlvbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSx3RUFBa0U7QUFHbEUseUVBQWlFO0FBQ2pFLHdEQUFvRDtBQUlwRCxTQUFnQixVQUFVLENBQ3RCLE1BQWlIO0lBRWpILElBQUksVUFBZ0QsQ0FBQztJQUNyRCxJQUFJLElBQUEsZ0NBQWEsRUFBQyxNQUFNLENBQUMsRUFBRSxDQUFDO1FBQ3hCLFVBQVUsR0FBRyxNQUE4QyxDQUFDO0lBQ2hFLENBQUM7U0FBTSxDQUFDO1FBQ0osVUFBVSxHQUFHO1lBQ1QsUUFBUSxFQUFFLE1BQTRFO1NBQ3pGLENBQUM7SUFDTixDQUFDO0lBRUQsT0FBTztRQUNILE9BQU8sQ0FBQyxVQUFtQixJQUFBLDRCQUFVLEdBQUU7WUFDbkMsTUFBTSxjQUFjLEdBQUcsSUFBSSxnQ0FBYyxDQUFDLE9BQU8sQ0FBQyxDQUFDO1lBRW5ELE9BQU8sY0FBYyxDQUFDLHFCQUFxQixDQUFDLFVBQVUsQ0FBQyxDQUFDO1FBQzVELENBQUM7S0FDSixDQUFDO0FBQ04sQ0FBQztBQW5CRCxnQ0FtQkMifQ==